import AiAnalysisResult from "./AiAnalysisResult";
import RelatedKeyword from "./RelatedKeyword";
import MeasurementResult from "./MeasurementResult";

export default function DetailDoubleChin({data, img}) {
    return (
        <MeasurementResult type="이중턱" description='얼굴의 "이중턱"은 턱 아래에 형성되는 두꺼운 지방이나 피부 주름을 가리키는 용어입니다. 얼굴의 이중턱은 특히 체중이 증가하거나 노화에 따라 피부의 탄력이 감소할 때 더욱 뚜렷해질 수 있습니다. 또한 유전적인 요인이나 생활습관에 따라 형성될 수도 있습니다.' 
        score={data.score}>
            <div className="row-wrap">
                <div className="img-wrap">
                    <div className="img-cont">
                        <img src={img.image_cross_polar_front} />

                        <div className="caption">2D</div>
                    </div>
                    {/* <div className="img-cont detail">
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                        <div className="img">
                            <img src={process.env.PUBLIC_URL + "/image/img_report_result_detail_01.png"} />
                        </div>
                    </div> */}
                </div>
                <section>
                    <p className="body3">
                        이중턱, 즉 턱 밑 지방은 체중 증가, 노화, 유전적 요인으로 인해 턱 아래에 지방이 생기는 것을 말합니다. 턱선을 흐릿하게 만들어 얼굴을 더욱 동그랗게 보이게 합니다. 치료에는 운동, 식단 변화, 지방 흡입술, 지방 감소 및 얼굴 윤곽 개선을 위한 키벨라 주사 등이 포함됩니다.
                    </p>
                </section>
            </div>

            <div className="row-wrap grow">
                <RelatedKeyword list={data.keyword} />

                <AiAnalysisResult 
                    text={data.aiResult} 
                />
            </div>
        </MeasurementResult>
    )
}